
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[50vh] flex items-center overflow-hidden pt-20">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/9ecd95607b18a4589a036a2c3c68be5d.jpg"
          alt="Professional Stump Grinding Services in Metro Atlanta"
          title="Atlanta Stump Grinding Pros - Professional Stump Removal"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-24 lg:py-32">
        <div className="flex flex-col items-center text-center">
          <div className="space-y-4 md:space-y-6 lg:space-y-8 max-w-5xl">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Atlanta's Best Stump Grinding
            </h2>
            
            <div className="w-16 md:w-24 h-1 bg-emerald-500 mx-auto"></div>
            
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-100 font-medium leading-relaxed max-w-2xl mx-auto">
              High quality, professional stump removal in Metro Atlanta
            </p>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center pt-2">
              <button 
                onClick={scrollToContact}
                className="px-6 md:px-8 py-3 md:py-4 bg-emerald-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-emerald-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                Get a Free Quote
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-6 lg:gap-8 justify-center pt-2 md:pt-4">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
                  <i className="ri-shield-check-line text-white text-base md:text-lg"></i>
                </div>
                <span className="text-xs md:text-sm text-white font-medium">Licensed & Insured</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
                  <i className="ri-leaf-line text-white text-base md:text-lg"></i>
                </div>
                <span className="text-xs md:text-sm text-white font-medium">Minimal Lawn Damage</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
                  <i className="ri-check-double-line text-white text-base md:text-lg"></i>
                </div>
                <span className="text-xs md:text-sm text-white font-medium">Complete Removal</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl md:text-3xl"></i>
      </div>
    </section>
  );
}
